import styled from "styled-components";
import PhoneInput from 'react-phone-number-input'

import {
    ButtonType,
    ContainerType,
    ContentType,
    InputType,
    LabelInputType,
    InputDownArrowType
} from "@dropDesk/presentation/components/inputs/input_phone_number/input_phone_number";
import {
    ButtonDisabledType,
    IconType
} from "@dropDesk/presentation/components/inputs/input_textarea_with_border/input_textarea_with_border";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";


export const Container = styled.div<ContainerType>`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => `${props.marginLeft}px`};
  margin-top: ${(props) => `${props.marginTop}px`};
  min-width: 100%;
  position: relative;
`;
export const Content = styled.div<ContentType>`
  height: ${(props) => `${props.size}px`};
  min-height: ${(props) => `${props.size}px`};
  min-width: 100%;
  background: ${(props) => props.background};
  display: flex;
  border-radius: ${(props) => props.usedBorder ? `5px` : 0};
  align-items: center;
  padding: 0 0 0 5px;
  border: ${props => props.usedBorder ? `1px solid ${props.border}` : 'auto'};
  border-bottom: ${props => !props.usedBorder ? `1px solid ${props.border}` : 'auto'};

  &:hover {
    border-color: transparent;
    box-shadow: ${props => props.usedBorder ? `0 0 0 2px ${hexToRGBA(props.accent, .58)}` : `0 4px 2px -2px ${hexToRGBA(props.accent, 0.58)}`};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }

  &:focus-within {
    border-color: transparent;
    box-shadow: ${props => props.usedBorder ? `0 0 0 2px ${hexToRGBA(props.accent, .58)}` : `0 4px 2px -2px ${hexToRGBA(props.accent, 0.58)}`};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }
`;

export const PhoneInputNumber = styled(PhoneInput).attrs({})<InputType>`
  display: flex;
  height: ${(props) => `${props.size}px`};
  min-height: ${(props) => `${props.size}px`};
  flex: 1;
  color: ${(props) => props.color};
  border: 0 !important;
  background-color: transparent;
  padding: 0 5px 0 5px;
  font-size: 15px;
  width: 100%;

  .PhoneInputInput {
    border: 0 !important;
    background: transparent;
    width: 100%;
  }

  &::placeholder {
    color: ${(props) => props.placeholdercolor};
  }
`;


export const RemoveFilter = styled.i<InputDownArrowType>`
  font-size: 16px;
  //position: absolute;
    // top: ${(props) => `${props.size / 2}px`};
  //right: 52px;
  color: ${(props) => props.iconColor};
  cursor: pointer;
  z-index: 2;

  &:hover {
    filter: brightness(80%);
  }
`;
export const Label = styled.span<LabelInputType>`
  font-size: 14px;
  font-weight: bold;
  color: ${props => props.color};
  margin: 0 0 1px 2px;
`;

export const ButtonRight = styled.button<ButtonType>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.background};
  color: ${(props) => props.letterColor};
  font-size: 12px;
  padding: 0 5px 2px 5px;
  height: 17px;
  min-height: 17px;
  border-radius: 5px;
  border: 0;
  flex-direction: row;
  font-weight: 500;

  &:hover {
    filter: brightness(80%);
  }

  &:disabled {
    filter: brightness(80%);
  }
`;

export const ContentArrowDown = styled.div<InputDownArrowType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  background: ${(props) => props.iconColor};
  min-height: ${(props) => `${props.size}px`};
  border-radius: 0 4px 4px 0;
  cursor: pointer;
`;


export const ContentButton = styled.div<ButtonDisabledType>`
  display: flex;
  cursor: ${props => props.disable ? 'no-drop' : 'auto'};
`;

export const Icon = styled.i<IconType>`
  color: ${(props) => props.color};
  font-size: ${(props) => `${props.fontsize}px`};
  cursor: ${props => props.disabled ? 'no-drop' : 'pointer'};

  &:hover {
    filter: brightness(80%);
  }
`;

export const Button = styled.button`
  display: flex;
  border: 0;
  background: transparent;
  margin: 0 3px;
  align-items: center;
  justify-content: center;

  &:disabled {
    pointer-events: none;
  }
`;
